module.exports = __webpack_public_path__ + "static/media/featured.c31ababf.svg";